import React from "react";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

const TextSliceSleek = ({ doc }) => {
  const {
    heading,
    subheading,
    description,
    bg_color,
    image: { url: imageUrl, alt: imageAlt },
    align_image_to_right,
  } = doc?.primary || {};
  const sectionStyle = { backgroundColor: bg_color };
  const alignClass = !imageUrl
    ? "justify-content-center no-image"
    : !align_image_to_right && "flex-row-reverse";
  return (
    <div className="py-5 py-2xl-5 text-sleek-slice prismic-slice" style={sectionStyle}>
      <div className="container container-width text-sleek-slice-container">
        <div className={`d-flex flex-wrap ${alignClass} text-sleek-slice-content-row`}>
          <div className="text-sleek-slice-content-block">
            <div className="text-sleek-slice-content-holder">
              {checkContentPresence(heading) && (
                <div className="sns-h2 text-theme-primary same-size-title text-center text-sleek-slice-title">
                  {textResolver(heading)}
                </div>
              )}
              {checkContentPresence(subheading) && (
                <div className="mt-2 mt-2xl-2 text-sleek-slice-subheading">
                  {textResolver(subheading)}
                </div>
              )}
              {checkContentPresence(description) && (
                <div className="mt-2 mt-2xl-2 text-center text-sleek-slice-subtitle">
                  {textResolver(description)}
                </div>
              )}
            </div>
          </div>
          {imageUrl && (
            <div className="text-sleek-slice-image-block">
              <div className="text-sleek-slice-image-holder">
                <PrismicImgix src={imageUrl} alt={imageAlt} />
              </div>
            </div>
          )}
        </div>
        <div className="mt-4 mt-2xl-4 d-flex flex-wrap align-items-center justify-content-center text-sleek-slice-btns-row">
          {doc?.items?.map(
            ({ cta_text, cta: { url = "", target = "" }, include_in_separate_line }, idx) => (
              <>
                {url ? (
                  include_in_separate_line ? (
                    <div
                      className="mt-3 mt-2xl-3 text-center text-sleek-slice-btns-holder next-row-btns"
                      key={`sleek-btn-${idx}`}
                    >
                      <PrismicLinkTag
                        urlText={cta_text}
                        url={url}
                        target={target}
                        className="mx-3 mx-2xl-3 font-weight-bold text-center"
                      />
                    </div>
                  ) : (
                    <span
                      className="mt-2 mt-md-0 text-center text-sleek-slice-btns-holder"
                      key={`sleek-btn-${idx}`}
                    >
                      <PrismicLinkTag
                        urlText={cta_text}
                        url={url}
                        target={target}
                        className="mx-3 mx-2xl-3 font-weight-bold text-center"
                      />
                    </span>
                  )
                ) : (
                  ""
                )}
              </>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default TextSliceSleek;
